import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {AccessService} from './access.service';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    private http = inject(HttpClient);
    private toastrService = inject(ToastrService);
    private accessService = inject(AccessService);

    request(action: string, dataObject: object = null): Observable<any> {

        return this.http
            .post('api/api.php', {
                action,
                data: dataObject,
            })
            .pipe(
                tap((response: any) => {
                    if (response?.errors) {
                        response.errors.forEach(error => {
                            this.toastrService.error(error, 'Fehler');
                        });
                    }

                    // no user returned for public actions
                    if (response.auth_user) {
                        this.accessService.user = response.auth_user;
                    }
                })
            );
    }
}




